import styled from "@emotion/styled";
import FileZone from "../../../utils/utilities/FileZone";

import { Grid, IconButton } from "@mui/material";

import { BasicFlex, LabelUpper, InputLabel } from "../../../utils/Common";

import { useFormikContext } from "formik";

import CloseIcon from '@mui/icons-material/CloseRounded';

import GalleryComponent from "../../../utils/utilities/Gallery";

import FileLabel from "../../../utils/utilities/FileLabel";

const ImageDisplay = styled(BasicFlex)`
  background-color: ${props => props.theme.colors.lightBg};
  padding: 1rem;
  border-radius: 8px;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
  margin-top: .5rem;
`

const ImageTile = styled.div`
  width: 20rem;
  height: 20rem;
  position: relative;
`

const NameBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, .4);
  color: white;
  padding: .2rem .5rem;
`

const CloseButton = styled(BasicFlex)`
  position: absolute;
  top: 0;
  right: 0;
  /* background-color: rgba(0, 0, 0, .4);
  color: white;
  padding: .2rem .5rem; */
`

const Label = styled(InputLabel)`
  margin-bottom: .5rem;
`

const MediaZone = () => {
  const {values, setFieldValue} = useFormikContext() || {};
  let media_urls = values.media_urls || [];

  // const removeImage = (index) => {
  //   media_urls.splice(index, 1);
  //   setFieldValue('media_urls', media_urls);
  // }

  const removeImage = (key) => {
    media_urls = media_urls.filter(file => file?.key !== key);
    setFieldValue('media_urls', media_urls);
  }

  return (
    <Grid size={{xs: 12}}>
      {media_urls?.length ? <>
        <LabelUpper $size="1.2rem">Existing Media</LabelUpper>
        <ImageDisplay justify="flex-start">
          {media_urls?.map(({key, originalname, label, thumbnail, signedUrl: url}, index) => (
            <GalleryComponent key={key} images={media_urls} imageIndex={index}
            fullScreen
            title={originalname}
              // toggle={
              // <ImageTile key={key}>
              //   <CloseButton justify="flex-end">
              //     <IconButton size="small" color="basic" onClick={() => removeImage(index)}>
              //       <CloseIcon fontSize="small" />
              //     </IconButton>
              //   </CloseButton>
              //   <img src={url} style={{width: '100%', height: '100%', objectFit: 'cover'}} />
              //   <NameBar>{label || originalname}</NameBar>
              // </ImageTile>
              // }
              toggle={
                <FileLabel
                  name={key}
                  label={label}
                  url={url}
                  removeMedium={removeImage}
                />
              }
            />
            )
          )}
        </ImageDisplay>
      </> : null}
      <Label>Add Media</Label>
      <FileZone name="media" />
    </Grid>
  );
};

export default MediaZone;